import * as React  from 'react';
// import * as moment from 'moment'
const moment = require('moment');
import { getDatePatternArray } from '../../WorkkardDetail/utils';

function resolveMonthDayIndex(dateParts) {
    const first = parseInt(dateParts?.[0], 10);
    const second = parseInt(dateParts?.[1], 10);
    if (first > 12 && second <= 12) {
        return { month: 1, day: 0 };
    }
    if (second > 12 && first <= 12) {
        return { month: 0, day: 1 };
    }
    return { month: 1, day: 0 };
}

export default class GetDate extends React.PureComponent{
    constructor(props) {
        super(props);
        this.getMonth = this.getMonth.bind(this);
        this.getYear = this.getYear.bind(this);
    }

    getMonth(month) {
        if(month){
            switch (month.trim()) {
                case '01':
                case '1': 
                    return 'Jan'
    
                case '02':
                case '2':
                    return 'Feb'
                case '03':
                case '3':
                    return 'Mar'
                case '04':
                case '4':
                    return 'Apr'
                case '05': 
                case '5': 
                    return 'May'
                case '06': 
                case '6':
                    return 'Jun'
                case '07': 
                case '7':
                    return 'Jul'
                case '08':
                case '8':
                    return 'Aug'
                case '09': 
                case '9':
                    return 'Sept'
                case '10': return 'Oct'
                case '11': return 'Nov'
                case '12': return 'Dec'
                default: return 'default'
            }
        }        
    }
    getYear(year){
        if (moment().year() == year)
            return ""
        else
            return ', ' + year        
    }
    render(){
        const {inputDate} = this.props;
        const date = getDatePatternArray(inputDate.key);
        const { month, day } = resolveMonthDayIndex(date);
        return(
            <span>{this.getMonth(date?.[month])} {date?.[day]}{this.getYear(date?.[2])}</span>
        )
    }
}